import {
	HTTP_CONFLICT,
	HTTP_CREATED,
	HTTP_GET,
	HTTP_NO_CONTENT,
	HTTP_NOT_FOUND,
	HTTP_OK,
	STATIC_API_KEYS,
} from "../../utils/constants";

const parseJson = (json, fallback = {}) => {
	try {
		if (typeof json === "string") {
			return JSON.parse(json);
		} else {
			console.error("Invalid JSON");
			return fallback;
		}
	} catch (e) {
		console.error("Invalid JSON");
	}

	return fallback;
};

const stringifyJson = (obj, fallback = "") => {
	if (typeof obj === "string") {
		return obj;
	}

	if (typeof obj === undefined) {
		return fallback;
	}

	try {
		return JSON.stringify(obj);
	} catch (e) {
		return fallback;
	}
};

const httpStatusText = (code) => {
	return (
		{
			[HTTP_OK]: "Ok",
			[HTTP_CREATED]: "Created",
			[HTTP_NO_CONTENT]: "No Content",
			[HTTP_CONFLICT]: "Conflict",
		}[code] || "Unknows"
	);
};

const getResponseDebugInfo = async (resp) => {
	let { status, url, statusText, type } = resp;

	if (!statusText || !statusText.length) {
		statusText = httpStatusText(status);
	}

	const response = await resp.text();
	resp.text = () => {
		return Promise.resolve(response);
	};
	resp.json = () => {
		return Promise.resolve(parseJson(response));
	};

	return {
		status,
		statusText,
		url,
		type,
		response,
	};
};

export async function fetchUrl(url, options = { method: HTTP_GET }) {
	const headers = {
		"Content-Type": "application/json",
		...options.headers,
	};

	const fetchOptions = { ...options, headers };

	return fetch(url, fetchOptions)
		.then((response) => {
			if (response.ok || response.status === HTTP_NOT_FOUND) {
				return response;
			}

			return getResponseDebugInfo(response).then((debugInfo) => {
				const { method, headers, cache, body } = fetchOptions;

				return response;
			});
		})
		.catch((e) => {
			throw e;
		});
}

const parseJsonResponse = async (resp) => {
	try {
		if (resp.ok) {
			const data = resp.status !== HTTP_NO_CONTENT ? await resp.json() : {};

			return { ok: true, status: resp.status, data };
		}

		const info = await getResponseDebugInfo(resp);
		const message = stringifyJson(info);
		const { status } = info;

		return Promise.reject({
			status,
			message,
		});
	} catch (e) {
		return Promise.reject(e);
	}
};

export async function fetchJson(api, options = { method: HTTP_GET, headers: {} }) {
	if (!navigator.onLine) {
		return { data: "No Internet Connection", status: 502 };
	}

	return fetchUrl(api, options)
		.then((resp) => {
			return parseJsonResponse(resp);
		})
		.catch((e) => {
			throw e;
		});
}
